import TagManager from 'react-gtm-module'
import ExperienceEvent from '../../constants/events'

export const gtmOpenExperiencePageAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.openExperiencePage,
      eventProps: {
        category: ExperienceEvent.category.openExperiencePageCategory,
        action: 'User open experience page',
        label: 'Open experience page',
        value: `User open experience page (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmOpenYourExperiencePageAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.openYourExperiencePage,
      eventProps: {
        category: ExperienceEvent.category.openYourExperiencePageCategory,
        action: 'User open your experience page',
        label: 'Open your experience page',
        value: `User open your experience page (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceDetailsAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceDetails,
      eventProps: {
        category: ExperienceEvent.category.viewExperienceDetailsCategory,
        action: 'User view experience details',
        label: 'View experience details',
        value: `User view experience details (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceItineraryAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceItinerary,
      eventProps: {
        category: ExperienceEvent.category.viewExperienceItineraryCategory,
        action: 'User view experience itinerary',
        label: 'View experience itinerary',
        value: `User view experience itinerary (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperiencePaymentAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperiencePayment,
      eventProps: {
        category: ExperienceEvent.category.viewExperiencePaymentCategory,
        action: 'User view experience payment',
        label: 'View experience payment',
        value: `User view experience payment (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceIntentionAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceIntention,
      eventProps: {
        category: ExperienceEvent.category.viewExperienceIntentionCategory,
        action: 'User view experience intention',
        label: 'View experience intention',
        value: `User view experience intention (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceOrientationCallAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceOrientationCall,
      eventProps: {
        category:
          ExperienceEvent.category.viewExperienceOrientationCallCategory,
        action: 'User view experience orientation call',
        label: 'View experience orientation call',
        value: `User view experience orientation call (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceBookIndividualSessionAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceBookIndividualSession,
      eventProps: {
        category:
          ExperienceEvent.category.viewExperienceBookIndividualSessionCategory,
        action: 'User view experience book individual session',
        label: 'View experience book individual session',
        value: `User view experience book individual session (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmPlayExperienceAudioAction = (
  experienceId,
  audioTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.playExperienceAudio,
      eventProps: {
        category: ExperienceEvent.category.playExperienceAudioCategory,
        action: 'User play experience audio',
        label: 'Play experience audio',
        value: `User play experience audio (experienceId - ${experienceId}, audioTitle - ${audioTitle})`,

        userId,
      },
    },
  })
}

export const gtmPlayExperienceVideoAction = (
  experienceId,
  videoTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.playExperienceVideo,
      eventProps: {
        category: ExperienceEvent.category.playExperienceVideoCategory,
        action: 'User play experience video',
        label: 'Play experience video',
        value: `User play experience video (experienceId - ${experienceId}, videoTitle - ${videoTitle})`,

        userId,
      },
    },
  })
}

export const gtmReadExperienceBlogAction = (
  experienceId,
  blogTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.readExperienceBlog,
      eventProps: {
        category: ExperienceEvent.category.readExperienceBlogCategory,
        action: 'User read experience blog',
        label: 'Read experience blog',
        value: `User read experience blog (experienceId - ${experienceId}, blogTitle - ${blogTitle})`,

        userId,
      },
    },
  })
}

export const gtmViewExperienceTravelChecklistAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.viewExperienceTravelChecklist,
      eventProps: {
        category:
          ExperienceEvent.category.viewExperienceTravelChecklistCategory,
        action: 'User view experience travel checklist',
        label: 'View experience travel checklist',
        value: `User view experience travel checklist (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

// export const gtmViewExperienceTravelDocumentAction = (
//   experienceId,
//   experienceTitle,
//   userId,
// ) => {
//   //GTM code
//   TagManager.dataLayer({
//     dataLayer: {
//       event: ExperienceEvent.event.viewExperienceTravelDocument,
//       eventProps: {
//         category: ExperienceEvent.category.viewExperienceTravelDocumentCategory,
//         action: 'User view experience travel document',
//         label: 'View experience travel document',
//         value: `User view experience travel document (experienceId - ${experienceId}, title - ${experienceTitle})`,

//         userId,
//       },
//     },
//   })
// }

export const gtmScheduleCallAction = (
  experienceId,
  experienceTitle,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleCall,
      eventProps: {
        category: ExperienceEvent.category.scheduleCallCategory,
        action: 'User submit schedule call form',
        label: 'Submit schedule call form',
        value: `User submit schedule call form (experienceId - ${experienceId}, title - ${experienceTitle})`,

        userId,
      },
    },
  })
}

export const gtmRescheduleSessionAction = (
  sessionLabel,
  sessionDateTime,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.rescheduleSession,
      eventProps: {
        category: ExperienceEvent.category.rescheduleSessionCategory,
        action: 'User reschedule session',
        label: 'Reschedule session',
        value: `User reschedule session (sessionLabel - ${sessionLabel}, date - ${sessionDateTime}${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmCancelSessionAction = (
  sessionLabel,
  sessionDateTime,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.cancelSession,
      eventProps: {
        category: ExperienceEvent.category.cancelSessionCategory,
        action: 'User cancel session',
        label: 'Cancel session',
        value: `User cancel session (sessionLabel - ${sessionLabel}, date - ${sessionDateTime}${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmScheduleSessionAction = (
  sessionLabel,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleSession,
      eventProps: {
        category: ExperienceEvent.category.scheduleSessionCategory,
        action: 'User schedule session',
        label: 'Schedule session',
        value: `User schedule session (sessionLabel - ${sessionLabel}${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmScheduleFirstSessionAction = (
  sessionLabel,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleFirstSession,
      eventProps: {
        category: ExperienceEvent.category.scheduleFirstSessionCategory,
        action: 'User schedule first session',
        label: 'Schedule first session',
        value: `User schedule first session (sessionLabel - ${sessionLabel}${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmScheduleAllSessionAction = (
  sessionLabel,
  userId,
  experienceId,
  sessionCount,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleAllSession,
      eventProps: {
        category: ExperienceEvent.category.scheduleAllSessionCategory,
        action: 'User schedule all session',
        label: 'Schedule all session',
        value: `User schedule all session (sessionCount - ${sessionCount}${
          sessionLabel ? `, sessionLabel - ${sessionLabel}` : ''
        }${experienceId ? `, experienceId - ${experienceId}` : ''})`,

        userId,
      },
    },
  })
}

export const gtmScheduleMoreIndividualSessionAction = (
  sessionLabel,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleMoreIndividualSession,
      eventProps: {
        category:
          ExperienceEvent.category.scheduleMoreIndividualSessionCategory,
        action: 'User schedule more individual session',
        label: 'Schedule more individual session',
        value: `User schedule more individual session (sessionLabel - ${sessionLabel}${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmScheduleMultipleSessionsAction = (
  sessionCount,
  sessionLabels,
  userId,
  experienceId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.scheduleMultipleSessions,
      eventProps: {
        category: ExperienceEvent.category.scheduleMultipleSessionsCategory,
        action: 'User schedule multiple sessions',
        label: 'Schedule multiple sessions',
        value: `User schedule multiple sessions (sessionCount - ${sessionCount},${
          experienceId ? `, experienceId - ${experienceId}` : ''
        })`,

        userId,
      },
    },
  })
}

export const gtmContinueExperiencePaymentMethodAction = (
  experienceId,
  paymentMethod,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.continueExperiencePaymentMethod,
      eventProps: {
        category:
          ExperienceEvent.category.continueExperiencePaymentMethodCategory,
        action: 'User continue experience payment method',
        label: 'Continue experience payment method',
        value: `User continue experience payment method (experienceId - ${experienceId}, paymentMethod - ${paymentMethod})`,

        userId,
      },
    },
  })
}

export const gtmContinueExperienceBillingInfoAction = (
  experienceId,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.continueExperienceBillingInfo,
      eventProps: {
        category:
          ExperienceEvent.category.continueExperienceBillingInfoCategory,
        action: 'User continue experience billing info',
        label: 'Continue experience billing info',
        value: `User continue experience billing info (experienceId - ${experienceId})`,

        userId,
      },
    },
  })
}

export const gtmMakeExperiencePaymentAction = (
  experienceId,
  paymentMethod,
  userId,
) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.makeExperiencePayment,
      eventProps: {
        category: ExperienceEvent.category.makeExperiencePaymentCategory,
        action: 'User make experience payment',
        label: 'Make experience payment',
        value: `User make experience payment (experienceId - ${experienceId}, paymentMethod - ${paymentMethod})`,

        userId,
      },
    },
  })
}

export const gtmListenLearningResourceTabAction = (userId, experienceId) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.listenLearningResource,
      eventProps: {
        category: ExperienceEvent.category.listenLearningResourceCategory,
        action: 'User clicked learning resource listen tab',
        label: 'Listen learning resource tab',
        value: `User clicked learning resource listen tab${
          experienceId ? ` (experienceId - ${experienceId})` : ''
        }`,

        userId,
      },
    },
  })
}

export const gtmWatchLearningResourceTabAction = (userId, experienceId) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.watchLearningResource,
      eventProps: {
        category: ExperienceEvent.category.watchLearningResourceCategory,
        action: 'User clicked learning resource watch tab',
        label: 'Watch learning resource tab',
        value: `User clicked learning resource watch tab${
          experienceId ? ` (experienceId - ${experienceId})` : ''
        }`,

        userId,
      },
    },
  })
}

export const gtmReadLearningResourceTabAction = (userId, experienceId) => {
  //GTM code
  TagManager.dataLayer({
    dataLayer: {
      event: ExperienceEvent.event.readLearningResource,
      eventProps: {
        category: ExperienceEvent.category.readLearningResourceCategory,
        action: 'User clicked learning resource read tab',
        label: 'Read learning resource tab',
        value: `User clicked learning resource read tab${
          experienceId ? ` (experienceId - ${experienceId})` : ''
        }`,

        userId,
      },
    },
  })
}
